(ns ductile.workflow.form-recorder)

;; TODO: unify in cljc
(defrecord WorkflowFn [form f])

(defn workflow-fn? [f]
  (instance? WorkflowFn f))
